// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js!../../css/App.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.skitterbook-edit-cover-container {
    position: relative;
    display: flex;
    flex-direction: column;
    height: fit-content;
    width: fit-content;
}

div.skitterbook-edit-controls {
    position: absolute;
    top: 0px;
}

div.skitterbook-edit-cover-text {
    display: flex;
    flex-direction: column;
    background-color: var(--color-region);
    gap: 0.25rem;
    width: fit-content;
}

    div.skitterbook-edit-cover-text > div:first-child {
        width: fit-content;
        padding: 0.5rem 0rem 0rem 0rem;
    }

    div.skitterbook-edit-cover-text > div:last-child {
        width: fit-content;
        padding: 0rem 0rem 0.5rem 0rem;
    }

div.edit-title-container {
    position: relative;
    margin-bottom: 0.25rem;
}

div.edit-cover-image-buttons {
    display: flex;
    flex-direction: column;
    justify-content: end;
}

div.edit-cover-image-container {
    position: relative;
}

    div.edit-cover-image-container.portrait {
        height: 75vh;
        max-width: 100%;
        aspect-ratio: var(--skitterbook-cover-aspect-ratio);
    }

    div.edit-cover-image-container.landscape {
        width: 100%;
        aspect-ratio: var(--skitterbook-cover-aspect-ratio);
    }

    div.edit-cover-image-container > img {
        width: 20rem;
        max-width: 480px;
        aspect-ratio: var(--skitterbook-cover-aspect-ratio);
    }


section.skitterbook-edit div.expander-body.expanded {
    max-height: fit-content;
}

div.edit-cover-image-buttons .base-button:first-child {
    margin: 0.5rem 0.5rem 0.25rem 0.5rem;
}

div.edit-cover-image-buttons .base-button:last-child {
    margin: 0.25rem 0.5rem 0.5rem 0.5rem;
}

div.edit-cover-image-buttons .glyph-button-content {
    justify-content: end;
}

    div.edit-cover-image-buttons .glyph-button-content > span {
        text-wrap-mode: nowrap;
    }
`, "",{"version":3,"sources":["webpack://./src/Skitterbook/css/SkitterBookCoverPage.css"],"names":[],"mappings":"AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,qCAAqC;IACrC,YAAY;IACZ,kBAAkB;AACtB;;IAEI;QACI,kBAAkB;QAClB,8BAA8B;IAClC;;IAEA;QACI,kBAAkB;QAClB,8BAA8B;IAClC;;AAEJ;IACI,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;AACtB;;IAEI;QACI,YAAY;QACZ,eAAe;QACf,mDAAmD;IACvD;;IAEA;QACI,WAAW;QACX,mDAAmD;IACvD;;IAEA;QACI,YAAY;QACZ,gBAAgB;QAChB,mDAAmD;IACvD;;;AAGJ;IACI,uBAAuB;AAC3B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oBAAoB;AACxB;;IAEI;QACI,sBAAsB;IAC1B","sourcesContent":["@import '../../css/App.css';\r\n\r\ndiv.skitterbook-edit-cover-container {\r\n    position: relative;\r\n    display: flex;\r\n    flex-direction: column;\r\n    height: fit-content;\r\n    width: fit-content;\r\n}\r\n\r\ndiv.skitterbook-edit-controls {\r\n    position: absolute;\r\n    top: 0px;\r\n}\r\n\r\ndiv.skitterbook-edit-cover-text {\r\n    display: flex;\r\n    flex-direction: column;\r\n    background-color: var(--color-region);\r\n    gap: 0.25rem;\r\n    width: fit-content;\r\n}\r\n\r\n    div.skitterbook-edit-cover-text > div:first-child {\r\n        width: fit-content;\r\n        padding: 0.5rem 0rem 0rem 0rem;\r\n    }\r\n\r\n    div.skitterbook-edit-cover-text > div:last-child {\r\n        width: fit-content;\r\n        padding: 0rem 0rem 0.5rem 0rem;\r\n    }\r\n\r\ndiv.edit-title-container {\r\n    position: relative;\r\n    margin-bottom: 0.25rem;\r\n}\r\n\r\ndiv.edit-cover-image-buttons {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: end;\r\n}\r\n\r\ndiv.edit-cover-image-container {\r\n    position: relative;\r\n}\r\n\r\n    div.edit-cover-image-container.portrait {\r\n        height: 75vh;\r\n        max-width: 100%;\r\n        aspect-ratio: var(--skitterbook-cover-aspect-ratio);\r\n    }\r\n\r\n    div.edit-cover-image-container.landscape {\r\n        width: 100%;\r\n        aspect-ratio: var(--skitterbook-cover-aspect-ratio);\r\n    }\r\n\r\n    div.edit-cover-image-container > img {\r\n        width: 20rem;\r\n        max-width: 480px;\r\n        aspect-ratio: var(--skitterbook-cover-aspect-ratio);\r\n    }\r\n\r\n\r\nsection.skitterbook-edit div.expander-body.expanded {\r\n    max-height: fit-content;\r\n}\r\n\r\ndiv.edit-cover-image-buttons .base-button:first-child {\r\n    margin: 0.5rem 0.5rem 0.25rem 0.5rem;\r\n}\r\n\r\ndiv.edit-cover-image-buttons .base-button:last-child {\r\n    margin: 0.25rem 0.5rem 0.5rem 0.5rem;\r\n}\r\n\r\ndiv.edit-cover-image-buttons .glyph-button-content {\r\n    justify-content: end;\r\n}\r\n\r\n    div.edit-cover-image-buttons .glyph-button-content > span {\r\n        text-wrap-mode: nowrap;\r\n    }\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
